import { mount } from 'svelte';
import Generate from './figures/Generate.svelte';
import Rank from './figures/Rank.svelte';
import Apply from './figures/Apply.svelte';

const figures: Record<string, any> = {
  generate: Generate,
  rank: Rank,
  apply: Apply,
};

function mountFigures() {
  document.querySelectorAll<HTMLElement>('[data-figure]').forEach((el) => {
    const name = el.dataset.figure;
    if (!name) return;
    const Component = figures[name];
    if (!Component) return;
    mount(Component, { target: el });
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', mountFigures);
} else {
  mountFigures();
}
